import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | undefined;

export function setAppInsights(instance: ApplicationInsights) {
    appInsights = instance;
}

export function getAppInsights(): ApplicationInsights | undefined {
    return appInsights;
}
